/* eslint-disable */
import fetch from '../utils/fetch'
import * as M from './__model'
export class VersionController {
  /**
   * 获取版本信息
   */

  public static checkVersion() {
    return fetch.get<M.AppReleaseResponse>('/version')
  }
}
export class BehaviorController {
  /**
   * 新增行为积分记录
   */

  public static addScores(scoreRequest: M.ScoreRequest) {
    return fetch.post<void>('/behavior/scoring/', scoreRequest)
  }

  /**
   * 删除行为积分记录
   */

  public static deleteComment(scoringRecordId: number) {
    return fetch.delete<void>('/behavior/scoring/', { params: { scoringRecordId } })
  }

  /**
   * 删除积分类型
   */

  public static deleteScoringType(scoringTypeId: number) {
    return fetch.delete<void>('/behavior/scoring/type', { params: { scoringTypeId } })
  }

  /**
   * 班级积分查询，按学生姓名排序
   */

  public static getClassScores(classId: number) {
    return fetch.get<M.ScoreResponse[]>('/behavior/scoring/class', { params: { classId } })
  }

  /**
   * 获取积分概览
   */

  public static getOverView() {
    return fetch.get<M.OverViewResponse>('/behavior/scoring/overview')
  }

  /**
   * 获取积分类型预设图标
   */

  public static getPreSetIcon() {
    return fetch.get<M.PresetIconResponse[]>('/behavior/scoring/type/preset-icon')
  }

  /**
   * 获取学生存在的所有学年，不包括将来的
   */

  public static getSchoolYearsOfStudent(studentId: number) {
    return fetch.get<M.SchoolYearResponse[]>('/behavior/scoring/schoolYears', {
      params: { studentId },
    })
  }

  /**
   * 检索积分类型
   */

  public static getScoringTypes() {
    return fetch.get<M.ScoringTypeResponse[]>('/behavior/scoring/type')
  }

  /**
   * 检索积分类型
   */

  public static getScoringTypesWithStudent(studentId: number) {
    return fetch.get<M.ScoringTypeResponse[]>('/behavior/scoring/student/type', {
      params: { studentId },
    })
  }

  /**
   * 积分详情上部
   */

  public static getStudentScoreStatistics(studentId: number, classId: number, era: string) {
    return fetch.get<M.StudentScoringResponse>('/behavior/scoring/student/statistics', {
      params: { studentId, classId, era },
    })
  }

  /**
   * 积分详情下部
   */

  public static getStudentScores(
    studentId: number,
    classId: number,
    era: string,
    pageCurrent: number,
    pageSize: number,
    scoringTypeId?: number
  ) {
    return fetch.get<M.PagedList<M.StudentScoringItemResponse>>(
      '/behavior/scoring/student/recent',
      { params: { studentId, classId, era, pageCurrent, pageSize, scoringTypeId } }
    )
  }

  /**
   * 更新行为积分记录评语
   */

  public static modifyComment(request: M.ScoreModifyRequest) {
    return fetch.put<void>('/behavior/scoring/', request)
  }

  /**
   * 新增积分类型
   */

  public static saveScoringType(request: M.ScoringTypeRequest) {
    return fetch.post<void>('/behavior/scoring/type', request)
  }
}
export class GradeConfigController {
  /**
   * 新增评估时间段
   */

  public static addGradePeriod(request: M.GradePeriodRequest) {
    return fetch.post<boolean>('/gradeConfig/addGradePeriod', {}, { params: { request } })
  }

  /**
   * 删除评估时间段信息
   */

  public static deletePeriod(gradePeriodId: number) {
    return fetch.delete<boolean>('/gradeConfig/deletePeriod', { params: { gradePeriodId } })
  }

  /**
   * 根据id查询评估时间段信息
   */

  public static getGradePeriodById(gradePeriodId: number) {
    return fetch.get<M.GradePeriodResponse>('/gradeConfig/getGradePeriodById', {
      params: { gradePeriodId },
    })
  }

  /**
   * 查询评估时间段信息列表
   */

  public static getGradePeriodList(request: M.GradePeriodPageRequest) {
    return fetch.get<M.PagedList<M.GradePeriodResponse>>('/gradeConfig/getGradePeriodList', {
      params: request,
    })
  }

  /**
   * 修改评估时间段
   */

  public static updateGradePeriod(request: M.GradePeriodRequest) {
    return fetch.put<boolean>('/gradeConfig/updateGradePeriod', {}, { params: { request } })
  }
}
export class TraceController {
  /**
   * 添加评论
   */

  public static addComment(request: M.TraceCommentRequest) {
    return fetch.post<number>('/trace/addComment', request)
  }

  /**
   * 审核成长记录
   */

  public static auditTrace(traceId: number, status: string, shareWithClass?: boolean) {
    return fetch.put<void>('/trace/auditTrace', {}, { params: { traceId, status, shareWithClass } })
  }

  /**
   * 批量审核成长记录
   */

  public static auditTraceBatch(request: M.TraceAuditBatchRequest) {
    return fetch.put<void>('/trace/auditTraceBatch', request)
  }

  /**
   * 删除记录评论
   */

  public static deleteComment(commentId: number) {
    return fetch.delete<void>('/trace/deleteComment', { params: { commentId } })
  }

  /**
   * 删除评语模板
   */

  public static deleteCommentTemplate(templateId: number) {
    return fetch.delete<void>('/trace/comment-template', { params: { templateId } })
  }

  /**
   * 获取单条成长记录
   */

  public static detailByComment(commentId: number) {
    return fetch.get<M.TraceResponse>('/trace/detailByComment', { params: { commentId } })
  }

  /**
   * 获取评语模板
   */

  public static getCommentTemplates() {
    return fetch.get<M.CommentTemplateResponse[]>('/trace/comment-template')
  }

  /**
   * 获取成长记录评论
   */

  public static getComments(traceId: number) {
    return fetch.get<M.TraceCommentResponse[]>('/trace/comments', { params: { traceId } })
  }

  /**
   * 获取选定班级的评估表列表
   */

  public static getGradingTablesByClass(classId: number) {
    return fetch.get<M.GradeTableResponse[]>('/trace/table/list/en-seed', { params: { classId } })
  }

  /**
   * 获取草稿
   */

  public static getTemplateDraft(draftId: number) {
    return fetch.get<M.DraftResponse>('/trace/traceDraft', { params: { draftId } })
  }

  /**
   * 获取草稿列表
   */

  public static getTemplateDrafts(classId?: number, traceType?: string) {
    return fetch.get<M.DraftResponse[]>('/trace/traceDrafts', { params: { classId, traceType } })
  }

  /**
   * 获取单条成长记录
   */

  public static getTrace(traceId: number) {
    return fetch.get<M.TraceResponse>('/trace', { params: { traceId } })
  }

  /**
   * 获取教授班级评估表
   */

  public static getTraceTables() {
    return fetch.get<M.GradeTableResponse[]>('/trace/gradingTables')
  }

  /**
   * 点赞/取消点赞
   */

  public static pressFavor(traceId: number, favored: boolean) {
    return fetch.post<void>('/trace/favor', {}, { params: { traceId, favored } })
  }

  /**
   * 查询审批成长记录
   */

  public static queryAuditTraces(request: M.AuditTraceRequest) {
    return fetch.get<M.PagedList<M.AuditTraceResponse>>('/trace/auditTraces', { params: request })
  }

  /**
   * 查找当前登录用户的班级
   */

  public static queryClassesOfMember(jobType: string) {
    return fetch.get<M.TeacherClassResponse[]>('/trace/classes', { params: { jobType } })
  }

  /**
   * 查看复制/编辑用的完整的成长记录信息
   */

  public static queryCompleteTrace(traceId: number, mode?: string) {
    return fetch.get<M.TraceInfoRequest>('/trace/complete', { params: { traceId, mode } })
  }

  /**
   * 通过班级查找评分类目
   */

  public static queryGradeClassByClass(classId: number) {
    return fetch.get<M.GradeTableStructureResponse>('/trace/grade/class', { params: { classId } })
  }

  /**
   * 通过班级查找评分类目(EnSeed)
   */

  public static queryGradeClassByClassEnSeed(classId: number, gradeTableId: number) {
    return fetch.get<M.GradeTableStructureResponse>('/trace/grade/class/en-seed', {
      params: { classId, gradeTableId },
    })
  }

  /**
   * 用于新增（编辑/复制）时查找学生的单项评分次数
   */

  public static queryGradeNumberOfTimes(nq: M.GradeNumberRequest) {
    return fetch.get<any>('/trace/student/gradeNum', { params: nq })
  }

  /**
   * 用于新增（编辑/复制）时查找学生的单项评分次数(EnSeed)
   */

  public static queryGradeNumberOfTimesEnSeed(nq: M.GradeNumberEnSeedRequest) {
    return fetch.get<any>('/trace/student/gradeNum/en-seed', { params: nq })
  }

  /**
   * 通过三级类目查找四级类目
   */

  public static queryGradePointClass(grade3Class: M.Grade3ClassRequest) {
    return fetch.get<M.GradeClassResponse[]>('/trace/grade/point', { params: grade3Class })
  }

  /**
   * 获取学期信息
   */

  public static querySemesters() {
    return fetch.get<M.SemesterResponse[]>('/trace/semesters')
  }

  /**
   * 通过班级查找学生
   */

  public static queryStudentsByClass(classId: number) {
    return fetch.get<M.StudentResponse[]>('/trace/classStudents', { params: { classId } })
  }

  /**
   * 成长记录弹框
   */

  public static queryTraceModal(
    gradeClassId: number,
    classId: number,
    studentId: number,
    semesterId: number,
    gradeTableId: number
  ) {
    return fetch.get<M.TraceResponse[]>('/trace/', {
      params: { gradeClassId, classId, studentId, semesterId, gradeTableId },
    })
  }

  /**
   * 成长记录弹框
   */

  public static queryTraceModalForEnseed(
    gradeClassId: number,
    classId: number,
    studentId: number,
    schoolYear: string,
    gradeTableId: number
  ) {
    return fetch.get<M.TraceResponse[]>('/trace/en-seed', {
      params: { gradeClassId, classId, studentId, schoolYear, gradeTableId },
    })
  }

  /**
   * 获取所有成长记录类型
   */

  public static queryTraceTypes() {
    return fetch.get<M.TraceTypeResponse[]>('/trace/types')
  }

  /**
   * 教师端获取成长记录
   */

  public static queryTraces(filterRequest: M.TraceFilterRequest) {
    return fetch.post<M.PagedList<M.TraceResponse>>('/trace/all', filterRequest)
  }

  /**
   * 删除成长记录
   */

  public static removeTrace(traceId: number) {
    return fetch.delete<boolean>('/trace/remove', { params: { traceId } })
  }

  /**
   * 移除成长记录的草稿
   */

  public static removeTraceDraft(draftId: number) {
    return fetch.delete<boolean>('/trace/removeDraft', { params: { draftId } })
  }

  /**
   * 批量保存成长记录
   */

  public static saveBatchTrace(request: M.TraceTemplateRequest) {
    return fetch.post<void>('/trace/batch', request)
  }

  /**
   * 保存批量草稿
   */

  public static saveBatchTraceAsDraft(request: M.BatchTraceDraftRequest) {
    return fetch.post<void>('/trace/batch/draft', request)
  }

  /**
   * 保存评语模板
   */

  public static saveCommentTemplate(commentTemplate: M.CommentTemplateRequest) {
    return fetch.post<void>('/trace/comment-template', commentTemplate)
  }

  /**
   * 添加成长记录
   */

  public static saveTrace(infoRequest: M.TraceInfoRequest) {
    return fetch.post<boolean>('/trace/save', infoRequest)
  }

  /**
   * 设定分享
   */

  public static setShare(traceId: number, isShared: boolean) {
    return fetch.get<void>('/trace/share', { params: { traceId, isShared } })
  }
}
export class AdminMemberController {
  /**
   * 新增人员
   */

  public static add(request: M.AdminMemberRequest) {
    return fetch.post<void>('/admin/member/add', request)
  }

  /**
   * 获取人员详情
   */

  public static delete(memberId: number) {
    return fetch.delete<void>('/admin/member/delete', { params: { memberId } })
  }

  /**
   * 获取人员详情
   */

  public static detail(memberId: number) {
    return fetch.get<M.MemberDetailResponse>('/admin/member/detail', { params: { memberId } })
  }

  /**
   * 获取人员列表
   */

  public static getPageList(request: M.MemberPageRequest) {
    return fetch.get<M.PagedList<M.MemberPageResponse>>('/admin/member/list', { params: request })
  }

  /**
   * 重置密码
   */

  public static resetPassword(memberId: number) {
    return fetch.put<void>('/admin/member/resetPassword', {}, { params: { memberId } })
  }

  /**
   * 修改人员
   */

  public static update(request: M.AdminMemberRequest) {
    return fetch.put<void>('/admin/member/update', request)
  }
}
export class ExcelController {}
export class WXController {
  /**
   * 创建菜单
   */

  public static createMenu(jsonString: string) {
    return fetch.post<void>('/weixin/createMenu', {}, { params: { jsonString } })
  }
}
export class PaintingController {
  /**
   * 删除painting
   */

  public static deletePainting(paintingId: number) {
    return fetch.delete<void>('/painting', { params: { paintingId } })
  }

  /**
   * 获取painting详情
   */

  public static getPaintingDetail(paintingId: number) {
    return fetch.get<M.PaintingResponse>('/painting', { params: { paintingId } })
  }

  /**
   * 获取绘画板列表
   */

  public static getPaintings(classId: number, pageCurrent: number, pageSize: number) {
    return fetch.get<M.PagedList<M.PaintingItemResponse>>('/painting/list', {
      params: { classId, pageCurrent, pageSize },
    })
  }

  /**
   * 新增更新painting
   */

  public static savePainting(request: M.PaintingRequest) {
    return fetch.post<void>('/painting', request)
  }
}
export class LoginController {
  /**
   * 登录接口
   */

  public static login(request: M.LoginRequest) {
    return fetch.post<M.LoginResponse>('/account/login', request)
  }

  /**
   * 管理员端登录接口
   */

  public static loginAdmin(request: M.LoginRequest) {
    return fetch.post<M.LoginResponse>('/account/loginAdmin', request)
  }

  /**
   * 经销商端登录接口
   */

  public static loginAgency(request: M.LoginRequest) {
    return fetch.post<M.LoginResponse>('/account/loginAgency', request)
  }

  /**
   * 登出接口
   */

  public static logout() {
    return fetch.get<void>('/account/logout')
  }

  /**
   * 重置密码请求
   */

  public static resetPassword(account: string, memberType: string) {
    return fetch.put<M.StringResponse>(
      '/account/reset-pwd',
      {},
      { params: { account, memberType } }
    )
  }

  /**
   * 重置密码请求
   */

  public static resetPasswordAdmin(memberId: number) {
    return fetch.put<void>('/account/reset-pwd/admin', {}, { params: { memberId } })
  }

  /**
   * 重置密码请求
   */

  public static resetPasswordReal(password: string, token: string, memberType: string) {
    return fetch.put<void>(
      '/account/reset-pwd/reset',
      {},
      { params: { password, token, memberType } }
    )
  }

  /**
   * 发送验证码
   */

  public static sendVerifyCode(mobile: string) {
    return fetch.get<boolean>('/account/vcodeSend', { params: { mobile } })
  }

  /**
   * 使用大平台token换取系统token
   */

  public static switchToken(accessToken: string) {
    return fetch.get<M.LoginResponse>('/account/switchToken', { params: { accessToken } })
  }
}
export class AttendanceController {
  /**
   * 审批通过
   */

  public static approve(leaveApplicationId: number) {
    return fetch.put<void>(
      '/attendance/leave-application/approve',
      {},
      { params: { leaveApplicationId } }
    )
  }

  /**
   * 拒绝请假申请
   */

  public static declineApplication(leaveApplicationId: number) {
    return fetch.put<void>(
      '/attendance/leave-application/decline',
      {},
      { params: { leaveApplicationId } }
    )
  }

  /**
   * 获取已审批请假申请列表
   */

  public static getApproved(
    pageCurrent: number,
    pageSize: number,
    classId: number,
    studentId: number
  ) {
    return fetch.get<M.PagedList<M.LeaveApplicationItemResponse>>(
      '/attendance/leave-application/approved',
      { params: { pageCurrent, pageSize, classId, studentId } }
    )
  }

  /**
   * 统计考勤-按日
   */

  public static getAttendanceDailyStatistics(classId: number, date: number) {
    return fetch.get<M.AttendanceStatisticResponseDaily>('/attendance/statistics/daily', {
      params: { classId, date },
    })
  }

  /**
   * 每日考勤查询
   */

  public static getAttendanceOfDayByClass(
    classId: number,
    pageCurrent: number,
    pageSize: number,
    date: number
  ) {
    return fetch.get<M.PagedList<M.AttendanceResponseWithStudent>>('/attendance/class', {
      params: { classId, pageCurrent, pageSize, date },
    })
  }

  /**
   * 统计考勤-按月
   */

  public static getAttendanceStatisticsByMonth(classId: number, date: number) {
    return fetch.get<M.AttendanceMonthByCResponse>('/attendance/statistics/monthly', {
      params: { classId, date },
    })
  }

  /**
   * 统计考勤-按学期
   */

  public static getAttendanceStatisticsBySemester(classId: number, semesterId: number) {
    return fetch.get<M.AttendanceStatisticResponse>('/attendance/statistics/semester', {
      params: { classId, semesterId },
    })
  }

  /**
   * 学生个人考勤统计-按月
   */

  public static getAttendanceStatisticsMonthlyByStudent(studentId: number, month: number) {
    return fetch.get<M.AttendanceMonthBySResponse>('/attendance/student/statistics/monthly', {
      params: { studentId, month },
    })
  }

  /**
   * 个人统计考勤-按月
   */

  public static getAttendanceStatisticsMonthlyByStudentForTeacher(
    request: M.AttdStatByStudentRequestM
  ) {
    return fetch.get<M.AttendanceMonthBySResponse>(
      '/attendance/teacher/student/statistics/monthly',
      { params: request }
    )
  }

  /**
   * 个人统计考勤-按学期
   */

  public static getAttendanceStatisticsSemesterByStudentForTeacher(
    request: M.AttdStatByStudentRequestS
  ) {
    return fetch.get<M.AttendanceStatisticByStudent>(
      '/attendance/teacher/student/statistics/semester',
      { params: request }
    )
  }

  /**
   * 获取班级列表及当前人数
   */

  public static getClassNum(word?: string) {
    return fetch.get<M.ClassNum[]>('/attendance/class/num', { params: { word } })
  }

  /**
   * 获取考勤可以修改开始日期
   */

  public static getHistoryEditStartDate(classId: number) {
    return fetch.get<number>('/attendance/date/edit/start', { params: { classId } })
  }

  /**
   * 获取历史月份
   */

  public static getHistoryMonths(classId: number, studentId?: number) {
    return fetch.get<number[]>('/attendance/month/history', { params: { classId, studentId } })
  }

  /**
   * 获取学生个人考勤开始时间（学年开始或入学日期）
   */

  public static getHistoryMonthsByStudent(studentId: number) {
    return fetch.get<number[]>('/attendance/student/statistics/months', { params: { studentId } })
  }

  /**
   * 获取历史学期
   */

  public static getHistorySemester(classId: number) {
    return fetch.get<M.SemesterResponse[]>('/attendance/semester/history', { params: { classId } })
  }

  /**
   * 获取考勤开始日期
   */

  public static getHistoryStartDate(classId: number) {
    return fetch.get<number>('/attendance/date/start', { params: { classId } })
  }

  /**
   * 获取待审批请假申请列表
   */

  public static getPending(
    pageCurrent: number,
    pageSize: number,
    classId: number,
    studentId: number
  ) {
    return fetch.get<M.PagedList<M.LeaveApplicationItemResponse>>(
      '/attendance/leave-application/pending',
      { params: { pageCurrent, pageSize, classId, studentId } }
    )
  }

  /**
   * 全校按日考勤统计
   */

  public static getSchoolAttendanceInfoByDay(date: number, currentPage: number, pageSize: number) {
    return fetch.get<M.SchoolAttendanceInfo>('/attendance/school/statistics/daily', {
      params: { date, currentPage, pageSize },
    })
  }

  /**
   * 全校按月考勤统计
   */

  public static getSchoolAttendanceInfoByMonth(
    date: number,
    currentPage: number,
    pageSize: number
  ) {
    return fetch.get<M.SchoolAttendanceInfo>('/attendance/school/statistics/Monthly', {
      params: { date, currentPage, pageSize },
    })
  }

  /**
   * 全校按学期考勤统计
   */

  public static getSchoolAttendanceInfoBySemester(
    semesterId: number,
    currentPage: number,
    pageSize: number
  ) {
    return fetch.get<M.SchoolAttendanceInfo>('/attendance/school/statistics/semester', {
      params: { semesterId, currentPage, pageSize },
    })
  }

  /**
   * 根据班级和月份查询学生
   */

  public static getStudentByMonth(classId: number, date: number) {
    return fetch.get<M.StudentResponse[]>('/attendance/class/students/month', {
      params: { classId, date },
    })
  }

  /**
   * 根据班级和学期查询学生
   */

  public static getStudentBySemester(classId: number, semesterId: number) {
    return fetch.get<M.StudentResponse[]>('/attendance/class/students/semester', {
      params: { classId, semesterId },
    })
  }

  /**
   * 设置所有学生均为全勤
   */

  public static setAllAttended(request: M.ClassAttendanceRequest) {
    return fetch.put<void>('/attendance/all', request)
  }

  /**
   * 设定考勤状态
   */

  public static setAttendance(request: M.AttendanceRequest) {
    return fetch.put<void>('/attendance/', request)
  }
}
export class GradingController {
  /**
   * 复制并替换类目
   */

  public static copyReplaceGradeClass(frameType: string, rank: number) {
    return fetch.put<void>('/grade/copyReplaceGradeClass', {}, { params: { frameType, rank } })
  }

  /**
   * 将指定评估表从指定年级移除
   */

  public static deleteGradeTable(tableId: number, sectionId: number) {
    return fetch.delete<void>('/grade/table/', { params: { tableId, sectionId } })
  }

  /**
   * 禁用评估表
   */

  public static disableSectionTable(
    sectionId: number,
    gradeTableId: number,
    gradeFrameId: number,
    schoolYear: string
  ) {
    return fetch.put<void>(
      '/grade/table/disable',
      {},
      { params: { sectionId, gradeTableId, gradeFrameId, schoolYear } }
    )
  }

  /**
   * 启用评估表
   */

  public static enableSectionTable(
    sectionId: number,
    gradeTableId: number,
    gradeFrameId: number,
    schoolYear: string
  ) {
    return fetch.put<void>(
      '/grade/table/enable',
      {},
      { params: { sectionId, gradeTableId, gradeFrameId, schoolYear } }
    )
  }

  /**
   * 查询班级评估表汇总
   */

  public static getClassSummary(classId: number, schoolYear: string, gradeTableId: number) {
    return fetch.get<M.ClassSummaryResponse>('/grade/table/class/summary', {
      params: { classId, schoolYear, gradeTableId },
    })
  }

  /**
   * Enseed 查询班级评估表汇总
   */

  public static getClassSummaryForEnSeed(
    classId: number,
    schoolYear: string,
    gradeTableId: number
  ) {
    return fetch.get<M.ClassSummaryResponse>('/grade/table/class/summary/en-seed', {
      params: { classId, schoolYear, gradeTableId },
    })
  }

  /**
   * 获取班级下拉框
   */

  public static getClasses() {
    return fetch.get<M.ClassResponse[]>('/grade/classes')
  }

  /**
   * 查看评估表默认结构
   */

  public static getDefaultTableStructure() {
    return fetch.get<M.GradeTableStructureResponse>('/grade/table/default')
  }

  /**
   * 获取三级类目以及评估等级描述
   */

  public static getGradeItemDetail(
    gradeClassId: number,
    traceId?: number,
    classId?: number,
    gradeTableId?: number
  ) {
    return fetch.get<M.GradeClassStructureResponse>('/grade/item/detail', {
      params: { gradeClassId, traceId, classId, gradeTableId },
    })
  }

  /**
   * 获取三级类目以及评估等级描述
   */

  public static getGradeItemDetailAll(
    gradeClassIds: number[],
    traceId?: number,
    classId?: number,
    gradeTableId?: number
  ) {
    return fetch.get<M.GradeClassStructureResponse[]>('/grade/item/detail/all', {
      params: { gradeClassIds, traceId, classId, gradeTableId },
    })
  }

  /**
   * 获取学校评估表列表
   */

  public static getGradeTable(request: M.GradeTableQeuryRequest) {
    return fetch.get<M.GradeTableItemResponse[]>('/grade/school/table/list', { params: request })
  }

  /**
   * 查看评估表结构
   */

  public static getGradeTableStructure(gradeTableId: number, sectionId?: number) {
    return fetch.get<M.GradeTableStructureResponse>('/grade/table/', {
      params: { gradeTableId, sectionId },
    })
  }

  /**
   * 获取评估表参数
   */

  public static getGradingParams() {
    return fetch.get<M.GradingParamResponse>('/grade/params')
  }

  /**
   * 获取选定学期的评估表列表
   */

  public static getGradingTablesBySchoolYear(schoolYear: string, classId?: number) {
    return fetch.get<M.GradeTableResponse[]>('/grade/table/list/en-seed', {
      params: { schoolYear, classId },
    })
  }

  /**
   * 获取选定学期的评估表列表
   */

  public static getGradingTablesBySemester(classId: number, semesterId: number) {
    return fetch.get<M.GradeTableResponse[]>('/grade/table/list', {
      params: { classId, semesterId },
    })
  }

  /**
   * 查询单个技能多次评分
   */

  public static getGradings(
    studentId: number,
    gradeTableId: number,
    classId: number,
    gradingClassId: number,
    schoolYear: string
  ) {
    return fetch.get<M.GradingResponse>('/grade/admin/student/one', {
      params: { studentId, gradeTableId, classId, gradingClassId, schoolYear },
    })
  }

  /**
   * 各班评估进度
   */

  public static getProgressOfEachClass(sectionId: number, gradeTableId: number) {
    return fetch.get<M.ClassGradingProgressResponse[]>('/grade/progress/classes', {
      params: { sectionId, gradeTableId },
    })
  }

  /**
   * 获取班级存在评估表的学期
   */

  public static getSchoolYear(classId: number) {
    return fetch.get<M.SchoolYearResponse[]>('/grade/semesters/en-seed', { params: { classId } })
  }

  /**
   * 获取班级存在评估表的学期
   */

  public static getSemesters(classId: number, schoolYear?: string) {
    return fetch.get<M.SemesterResponse[]>('/grade/semesters', { params: { classId, schoolYear } })
  }

  /**
   * 根据评估表查询学生列表
   */

  public static getStudentByGradingTable(classId: number, semesterId: number) {
    return fetch.get<M.StudentResponse[]>('/grade/student', { params: { classId, semesterId } })
  }

  /**
   * 根据评估表查询学生列表
   */

  public static getStudentByGradingTableForEnSeed(classId: number, schoolYear: string) {
    return fetch.get<M.StudentResponse[]>('/grade/student/en-seed', {
      params: { classId, schoolYear },
    })
  }

  /**
   * 根据学生查询各个技能的评分状况
   */

  public static getStudentGradingOfAdmin(
    studentId: number,
    gradeTableId: number,
    classId: number,
    schoolYear: string
  ) {
    return fetch.get<M.SkillGradingResponse[]>('/grade/admin/student/detail', {
      params: { studentId, gradeTableId, classId, schoolYear },
    })
  }

  /**
   * 根据学生查询各个技能的评分状况
   */

  public static getStudentGradingOfAdminForEnSeed(
    studentId: number,
    gradeTableId: number,
    classId: number,
    schoolYear: string
  ) {
    return fetch.get<M.SkillGradingWithRateResponse>('/grade/admin/student/detail/en-seed', {
      params: { studentId, gradeTableId, classId, schoolYear },
    })
  }

  /**
   * 新增修改评估表
   */

  public static saveGradeTable(request: M.GradeTableModifyRequest) {
    return fetch.post<void>('/grade/table/', request)
  }

  /**
   * 将评估表发送给家长
   */

  public static sendGradeTableToParent(tableId: number, classId: number, schoolYear: string) {
    return fetch.put<void>(
      '/grade/send/to/parent/en-seed',
      {},
      { params: { tableId, classId, schoolYear } }
    )
  }

  /**
   * 设置评估表参数
   */

  public static setGradingParams(request: M.GradingParamRequest) {
    return fetch.put<void>('/grade/params', request)
  }

  /**
   * 修改评估表类目-EnSeed
   */

  public static updateClassForEnSeed(request: M.GradeTableModifyEnSeedRequest) {
    return fetch.post<void>('/grade/table/updateClassForEnSeed', request)
  }

  /**
   * 更新评估表使用顺序
   */

  public static updateGradeOrder(request: M.GradeOrderRequest) {
    return fetch.put<void>('/grade/order', request)
  }
}
export class DiaryController {
  /**
   * 删除日记簿
   */

  public static deleteDiary(diaryEntryId: number) {
    return fetch.delete<void>('/diary/', { params: { diaryEntryId } })
  }

  /**
   * 获取日记簿记录详情
   */

  public static getDiaryEntry(diaryEntryId: number) {
    return fetch.get<M.DiaryEntryResponse>('/diary/', { params: { diaryEntryId } })
  }

  /**
   * 获取学生日记簿详情
   */

  public static getDiaryEntrySummary(
    pageCurrent: number,
    pageSize: number,
    studentId: number,
    primaryTypeId?: number,
    diaryEntryTypeId?: number,
    start?: number,
    end?: number
  ) {
    return fetch.get<M.PagedList<M.DiaryEntryItemResponse>>('/diary/by-student', {
      params: { pageCurrent, pageSize, studentId, primaryTypeId, diaryEntryTypeId, start, end },
    })
  }

  /**
   * 获取日记簿子类型
   */

  public static getDiaryEntryTypes(primaryTypeId: number) {
    return fetch.get<M.DropDownResponse[]>('/diary/entry-type', { params: { primaryTypeId } })
  }

  /**
   * 获取日记簿记录类型
   */

  public static getPrimaryTypes(containsHidden?: boolean) {
    return fetch.get<M.DropDownResponse[]>('/diary/primary-type', { params: { containsHidden } })
  }

  /**
   * 获取日记簿学生汇总列表
   */

  public static getStudentDiaryEntries(request: M.DiaryEntryQueryRequest) {
    return fetch.get<M.PagedList<M.StudentDiaryEntryResponse>>('/diary/entries', {
      params: request,
    })
  }

  /**
   * 获取日记簿学生汇总列表
   */

  public static getStudentDiaryInfo(studentId: number) {
    return fetch.get<M.StudentDiaryInfoResponse>('/diary/student-info', { params: { studentId } })
  }

  /**
   * 保存日记簿记录
   */

  public static saveDiary(diaryEntry: M.DiaryEntryRequest) {
    return fetch.post<void>('/diary/', diaryEntry)
  }
}
export class GradeFrameController {
  /**
   * 新增评分类目
   */

  public static addGradeClass(request: M.GradeClassRequest) {
    return fetch.post<string>('/gradeFrame/gradeClass/add', request)
  }

  /**
   * 删除评分类目
   */

  public static deleteGradeClass(gradeClassId: number, gradeTableId: number) {
    return fetch.delete<void>('/gradeFrame/gradeClass/delete', {
      params: { gradeClassId, gradeTableId },
    })
  }

  /**
   * 启用评估框架
   */

  public static ennable(gradeFrameId: number) {
    return fetch.put<void>('/gradeFrame/ennable', {}, { params: { gradeFrameId } })
  }

  /**
   * 查看评估表默认结构
   */

  public static getDefaultTableStructure(gradeFrameId: number) {
    return fetch.get<M.GradeTableStructureResponse>('/gradeFrame/table/default', {
      params: { gradeFrameId },
    })
  }

  /**
   * 查询评估框架详情
   */

  public static getGradeFrameInfo(gradeFrameId: number) {
    return fetch.get<M.GradeFrameInfoResponse>('/gradeFrame/detail', { params: { gradeFrameId } })
  }

  /**
   * 查询评估框架列表
   */

  public static getGradeFrameList() {
    return fetch.get<M.GradeFramePageResponse>('/gradeFrame/list')
  }

  /**
   * 查看评估表结构
   */

  public static getGradeTableStructure(gradeTableId: number, schoolYear: string) {
    return fetch.get<M.GradeTableStructureResponse>('/gradeFrame/table/', {
      params: { gradeTableId, schoolYear },
    })
  }

  /**
   * 获取评估表列表
   */

  public static getGradeTables(
    gradeFrameId: number,
    schoolYear: string,
    sectionBaseId?: number,
    gradeTableName?: string
  ) {
    return fetch.get<M.GradeTableItemResponse[]>('/gradeFrame/table/list', {
      params: { gradeFrameId, schoolYear, sectionBaseId, gradeTableName },
    })
  }

  /**
   * 新增修改评估表
   */

  public static saveGradeTable(request: M.GradeTableModifyRequest) {
    return fetch.post<number>('/gradeFrame/table/', request)
  }

  /**
   * 修改评分类目
   */

  public static updateGradeClass(request: M.GradeClassRequest) {
    return fetch.put<void>('/gradeFrame/gradeClass/update', request)
  }
}
export class SectionController {
  /**
   * 查询年级列表
   */

  public static getSectionList() {
    return fetch.get<M.SectionPageResponse[]>('/section/list')
  }

  /**
   * 修改年级
   */

  public static update(request: M.SectionRequest) {
    return fetch.put<void>('/section/update', request)
  }
}
export class PictureBookController {
  /**
   * 新增绘本资源
   */

  public static addPictureBookResources(request: M.PictureBookResourceRequest) {
    return fetch.post<void>('/pic-book/resources', request)
  }

  /**
   * 删除绘本资源
   */

  public static deletePictureBookResource(
    pictureBookId: number,
    resourceId: number,
    type?: string
  ) {
    return fetch.delete<void>('/pic-book/resources', {
      params: { pictureBookId, resourceId, type },
    })
  }

  /**
   * 获取开启时间列表
   */

  public static getBookOpenDates(bookId: number) {
    return fetch.get<M.BookOpenDateResponse[]>('/pic-book/book/openDate', { params: { bookId } })
  }

  /**
   * 教师查询绘本数据
   */

  public static getBundleBooksForTeachers(sectionId: number) {
    return fetch.get<M.PictureBundleResponse>('/pic-book/bundle/teacher', { params: { sectionId } })
  }

  /**
   * 获取操作记录
   */

  public static getOperationLog(
    bundleId: number,
    schoolId: number,
    pageCurrent: number,
    pageSize: number,
    studentName?: string,
    start?: number,
    end?: number
  ) {
    return fetch.get<M.PagedList<M.BundleOperationLogResponse>>('/pic-book/bundle/operation-log', {
      params: { bundleId, schoolId, pageCurrent, pageSize, studentName, start, end },
    })
  }

  /**
   * 获取绘本
   */

  public static getPictureBook(bookId: number) {
    return fetch.get<M.PictureBookResponse>('/pic-book/book', { params: { bookId } })
  }

  /**
   * 获取绘本资源列表
   */

  public static getPictureBookResources(pictureBookId: number, type?: string) {
    return fetch.get<M.BookResourceResponse[]>('/pic-book/resources', {
      params: { pictureBookId, type },
    })
  }

  /**
   * 获取绘本系列中的绘本
   */

  public static getPictureBundle(bundleId: number) {
    return fetch.get<M.PictureBookResponse[]>('/pic-book/bundle', { params: { bundleId } })
  }

  /**
   * 获取绘本系列列表
   */

  public static getPictureBundleList() {
    return fetch.get<M.BundleItemResponse[]>('/pic-book/bundle/list')
  }

  /**
   * 查询教授班级包含的年级
   */

  public static getSections() {
    return fetch.get<M.SpecialResponse[]>('/pic-book/section')
  }

  /**
   * 获取绘本订阅状况
   */

  public static getSubScribeInfo(bundleId: number, schoolId: number) {
    return fetch.get<M.SubscribeClassResponse[]>('/pic-book/bundle/subscription', {
      params: { bundleId, schoolId },
    })
  }

  /**
   * 开启绘本订阅
   */

  public static subscribe(bundleId: number, studentIds: number[], schoolId: number) {
    return fetch.put<void>(
      '/pic-book/bundle/subscribe',
      {},
      { params: { bundleId, studentIds, schoolId } }
    )
  }

  /**
   * 停止绘本订阅
   */

  public static unsubscribe(bundleId: number, studentIds: number[], schoolId: number) {
    return fetch.put<void>(
      '/pic-book/bundle/unsubscribe',
      {},
      { params: { bundleId, studentIds, schoolId } }
    )
  }

  /**
   * 修改开启时间
   */

  public static updateOpenDate(request: M.BookOpenDateRequest) {
    return fetch.put<void>('/pic-book/book/updateOpenDate', request)
  }

  /**
   * 修改附件关联学校
   */

  public static updateResourceSchool(request: M.BookResourceSchoolRequest) {
    return fetch.put<void>('/pic-book/book/updateResourceSchool', request)
  }

  /**
   * 上传绘本音频
   */

  public static uploadAudio(bookId: number, path: string, secretKey: string) {
    return fetch.get<void>('/pic-book/uploadAudio', { params: { bookId, path, secretKey } })
  }

  /**
   * 上传绘本
   */

  public static uploadBook(
    bundleId: number,
    path: string,
    name: string,
    enName: string,
    openDate: number,
    seq: number,
    secretKey: string,
    type?: string
  ) {
    return fetch.get<void>('/pic-book/uploadBook', {
      params: { bundleId, path, name, enName, openDate, seq, secretKey, type },
    })
  }

  /**
   * 上传单个文件
   */

  public static uploadSingle(path: string, key: string, secretKey: string) {
    return fetch.get<string>('/pic-book/uploadSingle', { params: { path, key, secretKey } })
  }
}
export class GradeReportController {
  /**
   * 生成评估报告
   */

  public static addGradeReport(request: M.AddGradeReportRequest) {
    return fetch.post<boolean>('/gradeReport/addGradeReport', request)
  }

  /**
   * 删除评估报告
   */

  public static deleteReport(reportId: number) {
    return fetch.delete<boolean>('/gradeReport/deleteReport', { params: { reportId } })
  }

  /**
   * 获取修改记录详情
   */

  public static getChangeDetail(changeId: number) {
    return fetch.get<M.ReportChangeDetailResponse>('/gradeReport/changeDetail', {
      params: { changeId },
    })
  }

  /**
   * 获取评估报告修改记录
   */

  public static getChangeList(classId?: number, semesterId?: number, gradePeriodId?: number) {
    return fetch.get<M.ReportChangeResponse[]>('/gradeReport/changeList', {
      params: { classId, semesterId, gradePeriodId },
    })
  }

  /**
   * 查询报告详情
   */

  public static queryReportInfo(reportId: number) {
    return fetch.get<M.GradeReportResponse>('/gradeReport/queryReportInfo', {
      params: { reportId },
    })
  }

  /**
   * 查询报告列表
   */

  public static queryReportList(request: M.GradeReportPageRequest) {
    return fetch.get<M.GradeReportPageResponse>('/gradeReport/queryReportList', { params: request })
  }

  /**
   * 查询评分类目下成长记录列表(无锡)
   */

  public static queryTraceListWX(
    gradeClassId: number,
    studentId: number,
    semesterId: number,
    gradePeriodId: number,
    classId: number
  ) {
    return fetch.get<M.GradeReportTraceResponse>('/gradeReport/queryTraceListWX', {
      params: { gradeClassId, studentId, semesterId, gradePeriodId, classId },
    })
  }

  /**
   * 查询评分类目下成长记录列表(余杭)
   */

  public static queryTraceListYH(
    gradeClassId: number,
    studentId: number,
    semesterId: number,
    gradePeriodId: number,
    classId: number
  ) {
    return fetch.get<M.GradeReportTraceResponseYH>('/gradeReport/queryTraceListYH', {
      params: { gradeClassId, studentId, semesterId, gradePeriodId, classId },
    })
  }

  /**
   * 发送报告
   */

  public static sendGradeReport(reportIds: number[]) {
    return fetch.put<void>('/gradeReport/sendGradeReport', reportIds)
  }

  /**
   * 修改报告
   */

  public static updateReport(request: M.GradeReportRequest) {
    return fetch.put<boolean>('/gradeReport/updateReport', request)
  }
}
export class PHDController {
  /**
   * 新增phd资源
   */

  public static addPHDBookResources(request: M.PHDBookResourceRequest) {
    return fetch.post<void>('/phd/resources', request)
  }

  /**
   * 删除绘本资源
   */

  public static deletePictureBookResource(phdBookId: number, resourceId: number) {
    return fetch.delete<void>('/phd/resources', { params: { phdBookId, resourceId } })
  }

  /**
   * 教师查询绘本数据
   */

  public static getBundleBooksForTeachers(sectionId: number) {
    return fetch.get<M.PictureBundleResponse>('/phd/bundle/teacher', { params: { sectionId } })
  }

  /**
   * 获取系列中的课程
   */

  public static getPHDBooks(bundleId: number) {
    return fetch.get<M.PictureBookResponse[]>('/phd/books', { params: { bundleId } })
  }

  /**
   * 获取PDH系列列表
   */

  public static getPHDBundleList() {
    return fetch.get<M.BundleItemResponse[]>('/phd/bundle/list')
  }

  /**
   * 获取phd课程
   */

  public static getPictureBook(bookId: number) {
    return fetch.get<M.PHDBookResponse>('/phd/book', { params: { bookId } })
  }

  /**
   * 获取phd资源列表
   */

  public static getPictureBookResources(phdBookId: number) {
    return fetch.get<M.ResourceResponse[]>('/phd/resources', { params: { phdBookId } })
  }
}
export class DailyCareController {
  /**
   * 获取班级生活记录列表
   */

  public static getClassDailyCareList(classId: number, date: number) {
    return fetch.get<M.ClassDailyCareResponse[]>('/daily-care/class', { params: { classId, date } })
  }

  /**
   * 获取生活记录类型列表
   */

  public static getDailyCareTypes() {
    return fetch.get<M.DailyCareTypeResponse[]>('/daily-care/type')
  }

  /**
   * 学生生活记录列表
   */

  public static getStudentDailyCareList(studentId: number, start?: number, end?: number) {
    return fetch.get<M.StudentDailyCareResponse[]>('/daily-care/student', {
      params: { studentId, start, end },
    })
  }

  /**
   * 添加新生活记录
   */

  public static postNewRecord(request: M.DailyCareBatchRequest) {
    return fetch.post<void>('/daily-care', request)
  }

  /**
   * 学生页面修改生活记录
   */

  public static saveStudentDailyCare(request: M.StudentDailyCareRequest) {
    return fetch.put<void>('/daily-care', request)
  }
}
export class SemesterController {
  /**
   * 查询所有学年信息
   */

  public static getAllSchoolYear() {
    return fetch.get<M.SchoolYearResponse[]>('/semester/getAllSchoolYear')
  }

  /**
   * 查询当前和过去学年信息
   */

  public static getNowAndPastSchoolYear() {
    return fetch.get<M.SchoolYearResponse[]>('/semester/getNowAndPastSchoolYear')
  }

  /**
   * 根据月份查询学年信息
   */

  public static getSchoolYearInfoByMonth(date: number) {
    return fetch.get<M.SchoolYearResponse>('/semester/getSchoolYearInfoByMonth', {
      params: { date },
    })
  }

  /**
   * 查询学期列表
   */

  public static getSemesterList() {
    return fetch.get<M.SemesterPageResponse[]>('/semester/list')
  }

  /**
   * 根据学年查询学期
   */

  public static getSemestersBySchoolYear(schoolYearId: number) {
    return fetch.get<M.SemesterDetailResponse>('/semester/getSemestersBySchoolYear', {
      params: { schoolYearId },
    })
  }

  /**
   * 根据学年查询学期
   */

  public static updateSemester(request: M.SemesterRequest) {
    return fetch.put<void>('/semester/updateSemester', request)
  }
}
export class NoticeController {
  /**
   * 新增通知
   */

  public static addNotice(request: M.NoticeInfoRequest) {
    return fetch.post<void>('/notice/add', request)
  }

  /**
   * 新增回复
   */

  public static addReply(request: M.NoticeCommentRequest) {
    return fetch.post<void>('/notice/addReply', request)
  }

  /**
   * 删除消息
   */

  public static deleteMessage(messageId: number) {
    return fetch.delete<void>('/notice/deleteMessage', { params: { messageId } })
  }

  /**
   * 删除通知
   */

  public static deleteNotice(noticeId: number, status: boolean) {
    return fetch.delete<void>('/notice/delete', { params: { noticeId, status } })
  }

  /**
   * 查询发出通知列表
   */

  public static getNoticeFromList(request: M.NoticeFromPageRequest) {
    return fetch.get<M.PagedList<M.NoticeFromPageResponse>>('/notice/getNoticeFromList', {
      params: request,
    })
  }

  /**
   * 查询校内通知详情
   */

  public static getNoticeInSchoolDetail(noticeId: number) {
    return fetch.get<M.NoticeInSchoolDetailResponse>('/notice/getDetailInSchool', {
      params: { noticeId },
    })
  }

  /**
   * 查询校内通知列表
   */

  public static getNoticeInSchoolList(request: M.NoticeToPageRequest) {
    return fetch.get<M.PagedList<M.NoticeInSchoolPageResponse>>('/notice/getToInSchoolList', {
      params: request,
    })
  }

  /**
   * 查询通知编辑信息
   */

  public static getNoticeInfo(noticeId: number) {
    return fetch.get<M.NoticeInfoResponse>('/notice/getNoticeInfo', { params: { noticeId } })
  }

  /**
   * 查询通知回复列表
   */

  public static getNoticeReplyList(request: M.NoticeCommentPageRequest) {
    return fetch.get<M.PagedList<M.NoticeReplyPageResponse>>('/notice/getReplyList', {
      params: request,
    })
  }

  /**
   * 查询历史通知详情
   */

  public static getParentNoticeList(noticeId: number) {
    return fetch.get<M.NoticeInSchoolDetailResponse[]>('/notice/getParentNoticeList', {
      params: { noticeId },
    })
  }

  /**
   * 查询确认信息
   */

  public static getReadInfo(noticeId: number) {
    return fetch.get<M.NoticeReadResponse>('/notice/getReadInfo', { params: { noticeId } })
  }

  /**
   * 根据回复id,查询回复上下文
   */

  public static getReplyInfo(noticeCommentId: number) {
    return fetch.get<M.NoticeCommentResponse>('/notice/getReplyInfo', {
      params: { noticeCommentId },
    })
  }

  /**
   * 根据通知id,查询通知下所有回复
   */

  public static getReplyInfoAll(noticeId: number) {
    return fetch.get<M.NoticeCommentResponse[]>('/notice/getReplyInfoAll', { params: { noticeId } })
  }

  /**
   * 查询是否有未读消息，返回map格式：{key:inSchool(校内通知)/reply(家长回复), value:true/false}
   */

  public static hasUnreadMessage() {
    return fetch.get<any>('/notice/hasUnreadMessage')
  }

  /**
   * 保存并发送
   */

  public static saveAndSendNotice(request: M.NoticeInfoRequest) {
    return fetch.post<boolean>('/notice/saveAndSend', request)
  }

  /**
   * 发送通知
   */

  public static sendNotice(noticeId: number) {
    return fetch.put<boolean>('/notice/send', {}, { params: { noticeId } })
  }

  /**
   * 发送成长记录评论通知
   */

  public static sendTraceNotice(request: M.TraceNoticeRequest) {
    return fetch.post<void>('/notice/sendTraceNotice', request)
  }

  /**
   * 设置通知下所有未读回复为已读
   */

  public static setAllCommentReaded(noticeId: number) {
    return fetch.put<void>('/notice/setAllCommentReaded', {}, { params: { noticeId } })
  }

  /**
   * 设置已读
   */

  public static setReaded(noticeId: number, messageId: number) {
    return fetch.put<void>('/notice/setReaded', {}, { params: { noticeId, messageId } })
  }

  /**
   * 修改通知
   */

  public static updateNotice(request: M.NoticeInfoRequest) {
    return fetch.put<void>('/notice/update', request)
  }
}
export class HomePageController {
  /**
   * 查询班级概况
   */

  public static getHomeClassList(request: M.HomePageRequest) {
    return fetch.get<M.PagedList<M.HomeClassResponse>>('/home/homeClassList', { params: request })
  }

  /**
   * 获取集团首页数据
   */

  public static getHomePageInformation() {
    return fetch.get<M.HomePageResponse>('/home/')
  }

  /**
   * 查询学校概况
   */

  public static getSchoolGeneralInfo(schoolId?: number) {
    return fetch.get<M.HomeSchoolResponse>('/home/schoolGeneralInfo', { params: { schoolId } })
  }
}
export class AgencyController {
  /**
   * 新增经销商
   */

  public static add(request: M.AgencyRequest) {
    return fetch.post<void>('/agency/add', request)
  }

  /**
   * 删除
   */

  public static delete(agencyId: number) {
    return fetch.delete<M.ResultResponse>('/agency/delete', { params: { agencyId } })
  }

  /**
   * 经销商详情
   */

  public static detail(agencyId: number) {
    return fetch.get<M.AgencyDetailResponse>('/agency/detail', { params: { agencyId } })
  }

  /**
   * 获取经销商列表
   */

  public static getPageList(request: M.PageRequest) {
    return fetch.get<M.PagedList<M.AgencyPageResponse>>('/agency/list', { params: request })
  }

  /**
   * 修改经销商
   */

  public static update(request: M.AgencyRequest) {
    return fetch.put<string[]>('/agency/update', request)
  }

  /**
   * 修改经销商状态
   */

  public static updateStatus(request: M.AgencyFreezeRequest) {
    return fetch.put<void>('/agency/updateStatus', request)
  }
}
export class DropDownController {
  /**
   * 获取经销商列表
   */

  public static getAgencyList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/agencyList')
  }

  /**
   * 有权限的教师列表
   */

  public static getAuthTeacherDropDown() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/authTeachers')
  }

  /**
   * 根据经销商查询评估框架下拉
   */

  public static getFramesByAgency(agencyId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/framesByAgency', { params: { agencyId } })
  }

  /**
   * 根据学校查询评估框架列表
   */

  public static getFramesBySchool(schoolId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/framesBySchool', { params: { schoolId } })
  }

  /**
   * 根据经销商查询评估框架下拉
   */

  public static getFramesUnderAgency(agencyId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/framesUnderAgency', { params: { agencyId } })
  }

  /**
   * 根据评估框架查询学年
   */

  public static getSchoolYearByFrame(gradeFrameId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/schoolYearByFrame', {
      params: { gradeFrameId },
    })
  }

  /**
   * 获取年级下拉框
   */

  public static getSectionBases(type?: string) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/sections', { params: { type } })
  }

  /**
   * 所有教师下拉列表
   */

  public static getTeacherDropDown() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/teacher')
  }

  /**
   * 查询入学年份下拉列表
   */

  public static queryEntrantYearList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/entrantYear')
  }

  /**
   * 根据学期查询评估时间段下拉列表
   */

  public static queryGradePeriodListBySemester(semesterId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/gradePeriodBySemester', {
      params: { semesterId },
    })
  }

  /**
   * 查询毕业年份下拉列表
   */

  public static queryGraduateYearList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/graduateYear')
  }

  /**
   * 查询角色下拉列表
   */

  public static queryRoleList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/role')
  }

  /**
   * 查询角色下拉列表
   */

  public static queryRoleListAdmin() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/role/admin')
  }

  /**
   * 查询角色下拉列表
   */

  public static queryRoleListAgency() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/role/agency')
  }

  /**
   * 查询学校下拉列表
   */

  public static querySchoolList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/school')
  }

  /**
   * 查询年级下拉列表
   */

  public static querySectionList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/section')
  }

  /**
   * 根据班级查询学期下拉列表
   */

  public static querySemesterByClass(classId: number) {
    return fetch.get<M.DropDownResponse[]>('/dropDown/semesterByClass', { params: { classId } })
  }

  /**
   * 查询学期下拉列表
   */

  public static querySemesterList() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/semester')
  }

  /**
   * 根据班级查询学生信息
   */

  public static queryStudentByClass(classId: number) {
    return fetch.get<M.StudentResponse[]>('/dropDown/studentByClass', { params: { classId } })
  }

  /**
   * 基础学年下拉
   */

  public static schoolYearBase() {
    return fetch.get<M.DropDownResponse[]>('/dropDown/schoolYearBase')
  }
}
export class FeatureController {
  /**
   * 根据邮箱获取功能列表
   */

  public static getFeatureListByEmail(email: string, schoolId: number) {
    return fetch.get<string[]>('/feature/featuresByEmail', { params: { email, schoolId } })
  }

  /**
   * 获取所有功能
   */

  public static getFeatures() {
    return fetch.get<M.FeatureResponse[]>('/feature/all')
  }

  /**
   * 根据经销商功能
   */

  public static getFeaturesByAgency(agencyId: number) {
    return fetch.get<M.FeatureResponse[]>('/feature/getByAgency', { params: { agencyId } })
  }

  /**
   * 获取学校权限列表（非管理员）
   */

  public static getSchoolActiveFeatures(schoolId: number, type?: string) {
    return fetch.get<M.FeatureResponse[]>('/feature/schoolFeature', { params: { schoolId, type } })
  }

  /**
   * 功能开关
   */

  public static updateSchoolFeature(school: M.SchoolFeatureRequest) {
    return fetch.put<void>('/feature/schoolFeature', school)
  }
}
export class CustomFieldController {
  /**
   * 删除受伤地点
   */

  public static deletePosition(positionId: number) {
    return fetch.delete<void>('/custom-field/position', { params: { positionId } })
  }

  /**
   * 删除获取成长记录类型
   */

  public static deleteTraceType(traceTypeId: number) {
    return fetch.delete<void>('/custom-field/trace-type', { params: { traceTypeId } })
  }

  /**
   * 受伤地点列表，key为字段id，value为字段值，name为字段创建者
   */

  public static getPositions() {
    return fetch.get<M.CustomFieldResponse[]>('/custom-field/position')
  }

  /**
   * 获取成长记录类型列表，key为字段id，value为字段值，name为字段创建者
   */

  public static getTraceTypes() {
    return fetch.get<M.CustomFieldResponse[]>('/custom-field/trace-type')
  }

  /**
   * 保存成长记录类型
   */

  public static savePosition(request: M.CustomFieldRequest) {
    return fetch.post<void>('/custom-field/position', request)
  }

  /**
   * 删除获取成长记录类型
   */

  public static saveTraceType(request: M.CustomFieldRequest) {
    return fetch.post<void>('/custom-field/trace-type', request)
  }
}
export class FeedBackController {
  /**
   * 创建反馈
   */

  public static createFeedBack(request: M.FeedBackRequest) {
    return fetch.post<void>('/feedback/', request)
  }
}
export class SchoolController {
  /**
   * 新增学校
   */

  public static add(request: M.SchoolRequest) {
    return fetch.post<void>('/school/add', request)
  }

  /**
   * 删除
   */

  public static delete(schoolId: number) {
    return fetch.delete<void>('/school/delete', { params: { schoolId } })
  }

  /**
   * 获取学校详情
   */

  public static detail(schoolId: number) {
    return fetch.get<M.SchoolDetailResponse>('/school/detail', { params: { schoolId } })
  }

  /**
   * 查询所有学校
   */

  public static getAllSchools() {
    return fetch.get<M.SchoolBriefInfoResponse[]>('/school/all')
  }

  /**
   * 根据功能查询学校
   */

  public static getByFeature(featureCode: string) {
    return fetch.get<M.SchoolBriefInfoResponse[]>('/school/getByFeature', {
      params: { featureCode },
    })
  }

  /**
   * 获取学校列表
   */

  public static getPageList(request: M.SchoolPageRequest) {
    return fetch.get<M.PagedList<M.SchoolPageResponse>>('/school/list', { params: request })
  }

  /**
   * 获取学校信息
   */

  public static getSchoolInfo(schoolId?: number) {
    return fetch.get<M.SchoolInfoResponse>('/school/info', { params: { schoolId } })
  }

  /**
   * 查询域名特殊的学校
   */

  public static getUrlUniqueSchools() {
    return fetch.get<M.SchoolUrlResponse[]>('/school/urlUniqueSchools')
  }

  /**
   * 查询学校简要信息列表
   */

  public static querySchoolBriefList() {
    return fetch.get<M.SchoolBriefInfoResponse[]>('/school/briefList')
  }

  /**
   * 修改学校
   */

  public static update(request: M.SchoolRequest) {
    return fetch.put<void>('/school/update', request)
  }

  /**
   * 修改学校状态
   */

  public static updateStatus(request: M.SchoolFreezeRequest) {
    return fetch.put<void>('/school/updateStatus', request)
  }
}
export class CommonController {
  /**
   * 得到七牛Token
   */

  public static getQiniuEtcToken() {
    return fetch.get<M.TokenResponse>('/common/qiniuToken')
  }

  /**
   * 得到七牛视频转码Token
   */

  public static getQiniuForVideo() {
    return fetch.get<M.TokenResponse>('/common/qiniuTokenForVideo')
  }

  /**
   * 通用翻译接口
   */

  public static translate(request: M.TranslateRequest) {
    return fetch.post<M.StringResponse>('/common/translate', request)
  }
}
export class JournalController {
  /**
   * 新增
   */

  public static add(request: M.JournalRequest) {
    return fetch.post<number>('/journal/add', request)
  }

  /**
   * 新增封面
   */

  public static addCover(request: M.CoverRequest) {
    return fetch.post<void>('/journal/addCover', request)
  }

  /**
   * 新增关联信息
   */

  public static addRelated(request: M.JournalRequest) {
    return fetch.post<void>('/journal/addFiles', request)
  }

  /**
   * 删除
   */

  public static delete(journalId: number) {
    return fetch.delete<void>('/journal/delete', { params: { journalId } })
  }

  /**
   * 删除封面
   */

  public static deleteCover(journalCoverId: number) {
    return fetch.delete<void>('/journal/deleteCover', { params: { journalCoverId } })
  }

  /**
   * 查询详情
   */

  public static detail(journalId: number) {
    return fetch.get<M.JournalDetailResponse>('/journal/detail', { params: { journalId } })
  }

  /**
   * 查询详情
   */

  public static getCovers() {
    return fetch.get<M.CoverResponse[]>('/journal/covers')
  }

  /**
   * 查询默认封面
   */

  public static getDefaultCover() {
    return fetch.get<M.CoverResponse>('/journal/defaultCover')
  }

  /**
   * 获取列表
   */

  public static getPageList(request: M.JournalPageRequest) {
    return fetch.get<M.PagedList<M.JournalPageResponse>>('/journal/list', { params: request })
  }

  /**
   * 发送
   */

  public static send(journalIds: number[]) {
    return fetch.put<void>('/journal/send', journalIds)
  }

  /**
   * 新增封面
   */

  public static setDefault(request: M.CoverRequest) {
    return fetch.put<void>('/journal/setDefault', request)
  }

  /**
   * 修改
   */

  public static update(request: M.JournalRequest) {
    return fetch.put<void>('/journal/update', request)
  }

  /**
   * 修改关联信息
   */

  public static updateFiles(request: M.JournalRequest) {
    return fetch.put<void>('/journal/updateFiles', request)
  }
}
export class MessageController {
  /**
   * 删除事故报告
   */

  public static deleteAccidentReport(accidentId: number) {
    return fetch.delete<void>('/message/accident/report/send', { params: { accidentId } })
  }

  /**
   * 获取事故报告
   */

  public static getAccidentInfo(accidentId: number) {
    return fetch.get<M.AccidentReportResponse>('/message/accident/report', {
      params: { accidentId },
    })
  }

  /**
   * 获取事故报告列表(pc)
   */

  public static getAccidentInfoList(
    pageCurrent: number,
    pageSize: number,
    classId?: number,
    studentId?: number,
    start?: number,
    end?: number
  ) {
    return fetch.get<M.PagedList<M.AccidentReportItemResponse>>('/message/accident/report/all', {
      params: { pageCurrent, pageSize, classId, studentId, start, end },
    })
  }

  /**
   * 获取当前学期
   */

  public static getCurrentSemester() {
    return fetch.get<M.SemesterResponse>('/message/currentSemester')
  }

  /**
   * 获取发送消息详情
   */

  public static getFromDetail(messageMasterId: number) {
    return fetch.get<M.MessageDetailResponse[]>('/message/fromDetail', {
      params: { messageMasterId },
    })
  }

  /**
   * 获取发件箱列表
   */

  public static getFromList(request: M.MessagePageRequest) {
    return fetch.get<M.PagedList<M.FromListResponse>>('/message/fromList', { params: request })
  }

  /**
   * 获取事故发生地点
   */

  public static getPosition() {
    return fetch.get<M.PositionResponse[]>('/message/accident/report/position')
  }

  /**
   * 查询读取情况
   */

  public static getReadInfo(messageMasterId: number) {
    return fetch.get<M.MessageReadResponse>('/message/readInfo', { params: { messageMasterId } })
  }

  /**
   * 获取学校创建时间
   */

  public static getSchoolBirthDay() {
    return fetch.get<number>('/message/schoolBirthDate')
  }

  /**
   * 事故简报
   */

  public static getStatisticsBrief() {
    return fetch.get<any>('/message/accident/report/statistics/brief')
  }

  /**
   * 统计图表数据
   */

  public static getStatisticsByTime(semesterId: number) {
    return fetch.get<any>('/message/accident/report/statistics', { params: { semesterId } })
  }

  /**
   * 获取系统消息
   */

  public static getSystemMessages(pageSize: number, pageNum: number, messageType?: string) {
    return fetch.get<M.PagedList<M.SystemMessageResponse>>('/message/system', {
      params: { pageSize, pageNum, messageType },
    })
  }

  /**
   * 获取接收消息详情
   */

  public static getToDetail(messageId: number) {
    return fetch.get<M.MessageDetailResponse[]>('/message/toDetail', { params: { messageId } })
  }

  /**
   * 获取收件箱列表
   */

  public static getToList(request: M.MessagePageRequest) {
    return fetch.get<M.PagedList<M.ToListResponse>>('/message/toList', { params: request })
  }

  /**
   * 获取系统消息列表
   */

  public static getToSystemList(request: M.MessagePageRequest) {
    return fetch.get<M.PagedList<M.ToListResponse>>('/message/toSystemList', { params: request })
  }

  /**
   * 获取未读消息数量
   */

  public static getUnRead() {
    return fetch.get<M.SpecialResponse>('/message/system/unread-num')
  }

  /**
   * 查询是否有未读消息
   */

  public static hasUnRead() {
    return fetch.get<boolean>('/message/hasUnRead')
  }

  /**
   * 查询是否有未读消息
   */

  public static hasUnReadSystem(type?: string) {
    return fetch.get<boolean>('/message/system/hasUnRead', { params: { type } })
  }

  /**
   * 发布事故报告
   */

  public static publishAccidentReport(accidentReportId: number) {
    return fetch.put<boolean>('/message/accident/report', {}, { params: { accidentReportId } })
  }

  /**
   * 保存事故报告
   */

  public static saveAccident(accident: M.AccidentRequest) {
    return fetch.post<boolean>('/message/accident/report', accident)
  }

  /**
   * 发送事故报告
   */

  public static sendAccidentReport(accidentId: number) {
    return fetch.put<boolean>('/message/accident/report/send', {}, { params: { accidentId } })
  }

  /**
   * 发送
   */

  public static sendMessage(request: M.MessageSaveRequest) {
    return fetch.post<void>('/message/send', request)
  }

  /**
   * 设置消息已读
   */

  public static setMessageRead(messageId: number) {
    return fetch.put<void>('/message/read', {}, { params: { messageId } })
  }

  /**
   * 设置消息已读
   */

  public static setRead(messageId: number) {
    return fetch.put<void>('/message/setRead', {}, { params: { messageId } })
  }
}
export class ClassController {
  /**
   * 新增班级信息
   */

  public static addClassInfo(classInfoRequest: M.ClassInfoRequest) {
    return fetch.post<boolean>('/class/add', classInfoRequest)
  }

  /**
   * 删除班级信息
   */

  public static deleteClassInfo(classId: number) {
    return fetch.delete<boolean>('/class/deleteClass', { params: { classId } })
  }

  /**
   * 修改班级信息
   */

  public static editClassInfo(classInfoRequest: M.ClassInfoRequest) {
    return fetch.put<boolean>('/class/edit', classInfoRequest)
  }

  /**
   * 查询毕业班级信息列表
   */

  public static getClassStudents(classId: number, date: number) {
    return fetch.get<M.StudentResponse[]>('/class/students', { params: { classId, date } })
  }

  /**
   * 查询班级下拉列表
   */

  public static queryClassDropDown(sectionId?: number) {
    return fetch.get<M.ClassResponse[]>('/class/classDropList', { params: { sectionId } })
  }

  /**
   * 查看班级信息
   */

  public static queryClassInfo(classId: number) {
    return fetch.get<M.ClassInfoResponse>('/class/info', { params: { classId } })
  }

  /**
   * 管理员查询班级信息列表
   */

  public static queryClassPageList(request: M.ClassPageRequest) {
    return fetch.get<M.PagedList<M.ClassPageResponse>>('/class/infoList', { params: request })
  }

  /**
   * 查询毕业班级信息列表
   */

  public static queryGradClassPageList(request: M.GradClassPageRequest) {
    return fetch.get<M.PagedList<M.ClassPageResponse>>('/class/gradInfoList', { params: request })
  }

  /**
   * 教师查询观察班级信息列表
   */

  public static queryObservingClassList(request: M.ClassPageRequest) {
    return fetch.get<M.PagedList<M.ClassPageResponse>>('/class/ObservingList', { params: request })
  }

  /**
   * 查询学生列表
   */

  public static queryStudentList() {
    return fetch.get<any>('/class/studentList')
  }

  /**
   * 查询教师列表
   */

  public static queryTeacherList() {
    return fetch.get<M.TeacherMemberResponse[]>('/class/teacherList')
  }

  /**
   * 教师查询教授班级信息列表
   */

  public static queryTeachingClassList(request: M.ClassPageRequest) {
    return fetch.get<M.PagedList<M.ClassPageResponse>>('/class/teachingList', { params: request })
  }
}
export class CalendarController {
  /**
   * 添加事件
   */

  public static addEvent(request: M.EventRequest) {
    return fetch.post<void>('/calendar/addEvent', request)
  }

  /**
   * 删除事件
   */

  public static deleteEvent(eventId: number) {
    return fetch.put<void>('/calendar/deleteEvent', {}, { params: { eventId } })
  }

  /**
   * 根据月份查询校历
   */

  public static getCalendarByMonth(
    dateStart: number,
    dateEnd: number,
    date: number,
    forParent: boolean
  ) {
    return fetch.get<M.CalendarResponse>('/calendar/byMonth', {
      params: { dateStart, dateEnd, date, forParent },
    })
  }

  /**
   * 查询事件信息
   */

  public static getEventInfo(eventId: number) {
    return fetch.get<M.EventResponse>('/calendar/getEventInfo', { params: { eventId } })
  }

  /**
   * 设置工作日/假期
   */

  public static setDayType(request: M.HolidaySettingRequest) {
    return fetch.post<void>('/calendar/setDayType', request)
  }

  /**
   * 修改事件
   */

  public static updateEvent(request: M.EventRequest) {
    return fetch.post<void>('/calendar/updateEvent', request)
  }
}
export class RecipeController {
  /**
   * 新增食谱
   */

  public static add(request: M.RecipeRequest) {
    return fetch.post<void>('/recipe/add', request)
  }

  /**
   * 删除食谱
   */

  public static delete(recipeId: number) {
    return fetch.delete<void>('/recipe/delete', { params: { recipeId } })
  }

  /**
   * 查询冲突日期
   */

  public static getConflictDates(startDate: number, endDate: number, recipeId?: number) {
    return fetch.get<number[]>('/recipe/conflictDates', {
      params: { startDate, endDate, recipeId },
    })
  }

  /**
   * 查询详情
   */

  public static getDetail(recipeId: number) {
    return fetch.get<M.RecipeDetailResponse>('/recipe/detail', { params: { recipeId } })
  }

  /**
   * 查询列表
   */

  public static getPageList(request: M.RecipePageRequest) {
    return fetch.get<M.PagedList<M.RecipePageResponse>>('/recipe/list', { params: request })
  }

  /**
   * 导入食谱
   */

  public static importRecipe(file: any) {
    return fetch.post<string[]>('/recipe/import', {}, { params: { file } })
  }

  /**
   * 修改食谱
   */

  public static update(request: M.RecipeRequest) {
    return fetch.put<void>('/recipe/update', request)
  }
}
export class StudentController {
  /**
   * 新增
   */

  public static addStudent(request: M.StudentAddRequest) {
    return fetch.post<void>('/student/', request)
  }

  /**
   * 将学生加入指定班级
   */

  public static addStudentToClass(studentId: number, classId: number) {
    return fetch.put<void>('/student/class', {}, { params: { studentId, classId } })
  }

  /**
   * 批量导入学生
   */

  public static batchImport(url: string) {
    return fetch.post<M.ImportResponse>('/student/batchImport', {}, { params: { url } })
  }

  /**
   * 保存学生信息
   */

  public static changeStudentInfo(student: M.StudentRequest) {
    return fetch.put<void>('/student/', student)
  }

  /**
   * 删除学生家长
   */

  public static deleteParentByStudent(studentId: number, parentId: number) {
    return fetch.delete<void>('/student/deleteParent', { params: { studentId, parentId } })
  }

  /**
   * 删除学生
   */

  public static deleteStudent(studentId: number) {
    return fetch.delete<void>('/student/', { params: { studentId } })
  }

  /**
   * 将学生移出指定班级
   */

  public static deleteStudentFromClass(studentId: number, classId: number) {
    return fetch.delete<void>('/student/class', { params: { studentId, classId } })
  }

  /**
   * 学生列表查询
   */

  public static getAllStudent(request: M.StudentQueryRequest) {
    return fetch.get<M.PagedList<M.StudentResponse>>('/student/all', { params: request })
  }

  /**
   * 获取班级列表及当前人数
   */

  public static getClassNum(word?: string) {
    return fetch.get<M.ClassNum[]>('/student/class/num', { params: { word } })
  }

  /**
   * 毕业生查询
   */

  public static getGraduates(request: M.GraduatesQueryRequest) {
    return fetch.get<M.PagedList<M.StudentResponse>>('/student/graduates', { params: request })
  }

  /**
   * 查询单个学生信息
   */

  public static getStudent(studentId: number) {
    return fetch.get<M.StudentInfoResponse>('/student/', { params: { studentId } })
  }

  /**
   * 查询学生下拉列表
   */

  public static getStudentDropDown() {
    return fetch.get<any>('/student/getStudentDropDown')
  }

  /**
   * 查询学生编辑信息
   */

  public static getStudentEdit(studentId: number) {
    return fetch.get<M.StudentEditResponse>('/student/getStudentEdit', { params: { studentId } })
  }

  /**
   * 发送邀请函
   */

  public static sendInviteMessage(studentIds: number[]) {
    return fetch.get<void>('/student/sendInviteMessage', { params: { studentIds } })
  }

  /**
   * 设置主家长
   */

  public static setMajorParent(studentId: number, parentId: number) {
    return fetch.put<void>('/student/setMajor', {}, { params: { studentId, parentId } })
  }

  /**
   * 招生同步学生
   */

  public static syncFromEas(request: M.SyncStudentRequest) {
    return fetch.post<M.SyncStudentResponse>('/student/syncFromEas', request)
  }
}
export class ResourceController {
  /**
   * 向班级的相册中添加照片或视频
   */

  public static addPhotos(resourceIds: number[], classId: number) {
    return fetch.post<void>('/resource/photos', {}, { params: { resourceIds, classId } })
  }

  /**
   * 向班级的相册中添加照片或视频
   */

  public static deletePhotos(resourceIds: number[], classId: number) {
    return fetch.delete<void>('/resource/photos', { params: { resourceIds, classId } })
  }

  /**
   * 查询班级相册
   */

  public static getPhotos(
    classId: number,
    monthStart: number,
    monthSize: number,
    resourceType?: string,
    sourceType?: string
  ) {
    return fetch.get<M.PhotoResponse[]>('/resource/photos', {
      params: { classId, monthStart, monthSize, resourceType, sourceType },
    })
  }

  /**
   * 保存资源信息
   */

  public static saveResource(request: M.ResourceRequest) {
    return fetch.post<number>('/resource/save', request)
  }
}
export class MemberController {
  /**
   * 新增教师
   */

  public static addForSsO(request: M.TeacherAddRequest) {
    return fetch.post<void>('/member/addForSsO', request)
  }

  /**
   * 新增人员信息
   */

  public static addMemberInfo(memberRequest: M.MemberRequest) {
    return fetch.post<boolean>('/member/add', memberRequest)
  }

  /**
   * 批量导入教师
   */

  public static batchImport(url: string) {
    return fetch.post<M.ImportResponse>('/member/batchImport', {}, { params: { url } })
  }

  /**
   * 修改密码
   */

  public static changePassword(request: M.PasswordRequest) {
    return fetch.put<boolean>('/member/changePassword', request)
  }

  /**
   * 删除人员信息
   */

  public static deleteMember(memberId: number) {
    return fetch.delete<boolean>('/member/delete', { params: { memberId } })
  }

  /**
   * 禁用
   */

  public static freeze(request: M.TeacherFreezeRequest) {
    return fetch.put<void>('/member/freeze', request)
  }

  /**
   * 根据账号查询教师信息
   */

  public static getBySchool(schoolId: number, secretKey: string) {
    return fetch.get<M.TeacherForSsoResponse[]>('/member/getByEmailAndSchool', {
      params: { schoolId, secretKey },
    })
  }

  /**
   * 获取所有学校管理员
   */

  public static getSchoolAdmins() {
    return fetch.get<M.MemberSchoolResponse[]>('/member/schoolAdmins')
  }

  /**
   * 查询账号在其他学校的信息
   */

  public static infoInAllSchool(mobile: string) {
    return fetch.get<M.MemberSchoolClassResponse>('/member/infoInAllSchool', { params: { mobile } })
  }

  /**
   * 验证能否删除人员
   */

  public static memberDeleteVerify(memberId: number) {
    return fetch.get<string[]>('/member/deleteVerify', { params: { memberId } })
  }

  /**
   * 查询人员信息列表(集团控制台)
   */

  public static queryAllMemberList(request: M.MemberPageRequest) {
    return fetch.get<M.PagedList<M.MemberListResponse>>('/member/infoList/all', { params: request })
  }

  /**
   * 查询班级下拉列表,人员页面专用
   */

  public static queryClassDropList() {
    return fetch.get<M.ClassDropDownResponse[]>('/member/classDropList')
  }

  /**
   * 查询人员信息列表
   */

  public static queryMemberList(request: M.MemberPageRequest) {
    return fetch.get<M.PagedList<M.MemberListResponse>>('/member/infoList', { params: request })
  }

  /**
   * 查看人员信息
   */

  public static queryTeacherMemberInfo(memberId: number) {
    return fetch.get<M.TeacherMemberResponse>('/member/info', { params: { memberId } })
  }

  /**
   * 查询用户信息
   */

  public static queryUserInfo() {
    return fetch.get<M.MemberResponse>('/member/userInfo')
  }

  /**
   * 修改人员信息
   */

  public static updateMemberInfo(memberRequest: M.MemberRequest) {
    return fetch.put<string[]>('/member/update', memberRequest)
  }

  /**
   * 修改个人信息
   */

  public static updatePersonalInfo(request: M.PersonalInfoRequest) {
    return fetch.put<boolean>('/member/updatePersonalInfo', request)
  }
}
